import { exists } from '@/api'
import { CollectionListStatus } from '@/types'
import { dateToPlainFormat } from '@/utils'

export interface CollectionList {
  id: number
  name: string
  nameKana: string
  registrationCount: number
  releaseStartDate: string
  releaseEndDate: string
  status: CollectionListStatus
  unlimitedFlag: boolean
  priority: number
  revision: number
}

export function CollectionListFromJSON(json: any): CollectionList {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    registrationCount: exists(json, 'registration_count')
      ? json.registration_count
      : 0,
    releaseStartDate: exists(json, 'release_start_date')
      ? dateToPlainFormat(json.release_start_date)
      : '',
    releaseEndDate: exists(json, 'release_end_date')
      ? dateToPlainFormat(json.release_end_date)
      : '',
    status: exists(json, 'status') ? json.status : CollectionListStatus.Private,
    unlimitedFlag: exists(json, 'unlimited_flag') ? json.unlimited_flag : false,
    priority: exists(json, 'priority') ? json.priority : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
